"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.partsToDisplay = partsToDisplay;
const Kind_1 = require("../Kind");
const toDisplay_js_1 = require("./toDisplay.js");
/**
 * Converts an array of mf elements to an array of formatting information
 * @param {Array<Object>} result of the parse method
 */
function partsToDisplay(parts) {
    let lines = [];
    for (let part of parts) {
        if (lines.length > 0)
            lines.push({ kind: Kind_1.Kind.SALT, value: '•' });
        for (let partLine of part) {
            lines.push(partLine);
            if (partLine.multiplier) {
                lines.push({
                    kind: Kind_1.Kind.MULTIPLIER,
                    value: partLine.multiplier,
                });
            }
        }
    }
    return (0, toDisplay_js_1.toDisplay)(lines);
}
//# sourceMappingURL=partsToDisplay.js.map